import React from 'react';
import CollectionPreferences from '@cloudscape-design/components/collection-preferences';
import {TablePreferencesProps } from "../../types/types";

const TablePreferences: React.FC<TablePreferencesProps> = ({
  preferences,
  setPreferences,
  setCurrentPage,
  columnOptions,
  pageSizeOptions,
}) => {
  return (
    <CollectionPreferences
      title="Preferences"
      cancelLabel="Cancel"
      confirmLabel="Confirm"
      onConfirm={({ detail }) => {
        setPreferences(detail);
        if (detail.pageSize !== preferences.pageSize) setCurrentPage(1);
      }}
      preferences={preferences}
      pageSizePreference={{
        title: 'Page size',
        options: pageSizeOptions,  // Use passed page size options
      }}
      wrapLinesPreference={{
        label: 'Wrap lines',
        description: 'Select to see all the text and wrap the lines',
      }}
      stripedRowsPreference={{
        label: 'Striped rows',
        description: 'Select to add alternating shaded rows',
      }}
      contentDensityPreference={{
        label: 'Compact mode',
        description: 'Select to display content in a denser, more compact mode',
      }}
      contentDisplayPreference={{
        title: 'Column preferences',
        description: 'Customize the columns visibility and order.',
        options: columnOptions,  // Use passed column options
      }}
      stickyColumnsPreference={{
        firstColumns: {
          title: 'Stick first column(s)',
          description: 'Keep the first column(s) visible while scrolling.',
          options: [
            { label: 'None', value: 0 },
            { label: 'First column', value: 1 },
            { label: 'First two columns', value: 2 },
          ],
        },
        lastColumns: {
          title: 'Stick last column',
          description: 'Keep the last column visible while scrolling.',
          options: [
            { label: 'None', value: 0 },
            { label: 'Last column', value: 1 },
          ],
        },
      }}
    />
  );
};

export default TablePreferences;
